// Routes path
export enum AppRoutes {
   HOME_ROUTE = '/',
   PAYMENT_ROUTE = '/payment/:paymentKey',
   STATUS_ROUTE = '/status',
   ERROR_ROUTE = '/error',
}
